import { PortalType } from "@studyportals/domain-client";
import { EducationLevelFilterOptionValue } from "@studyportals/search-filters/server-side";

const getEducationLevel = (): EducationLevelFilterOptionValue[] => {
	switch (window.PortalType) {
	case PortalType.BACHELOR:
		return [EducationLevelFilterOptionValue.BACHELOR];
	case PortalType.MASTER:
		return [EducationLevelFilterOptionValue.MASTER];
	case PortalType.PHD:
		return [EducationLevelFilterOptionValue.PHD];
	case PortalType.SHORT:
		return [EducationLevelFilterOptionValue.SHORT_COURSE];
	case PortalType.DISTANCE_LEARNING:
		return [EducationLevelFilterOptionValue.DISTANCE_LEARNING];
	default:
		return [EducationLevelFilterOptionValue.MASTER];
	}
}

export default getEducationLevel;